import { Link } from "react-router-dom";
import { allSpecials } from "@/lib/media";

export default function SpecialsSection() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {allSpecials.map((special) => (
        <Link
          key={special.id}
          to={`/special/${special.id}`}
          className="group relative block rounded-lg overflow-hidden border border-background-200/70 bg-background-100 cursor-pointer"
        >
          <div className="relative w-full h-48 md:h-52 overflow-hidden">
            <img
              src={special.cover}
              alt={`${special.title} 专题封面`}
              title={`${special.title} 影视专题`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/40 to-transparent" />
            <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[11px] font-bold">
              {special.tag}
            </span>
          </div>
          <div className="p-4 md:p-5">
            <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-400 transition-colors">
              {special.title}
            </h3>
            <p className="mt-1 text-xs text-foreground-500">{special.subtitle}</p>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">
              {special.intro}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-400">
              共 {special.mediaIds.length} 部片单
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}